import React from 'react';
import Pill from 'components/Widget/Pill';
import { EditFrameEntry } from 'dragonmouse-shared/interfaces';
import { MenuItemAction } from 'menu/MenuItem';
import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import { getElementName } from 'utils';
import * as S from './EditEntry/styles';

interface EditEntryProps {
	entry: EditFrameEntry;
}

const EditEntry = ({ entry }: EditEntryProps) => {
	const dispatch = useDispatch();

	const onContextMenuInPrompt = (e: React.MouseEvent) => {
		const selection = window.getSelection();
		const selectedText = selection?.toString() || null;

		if (selectedText) {
			e.preventDefault();
			const menuItems = [MenuItemAction.createCopyText(selectedText)];
			dispatch(
				showContextMenu({
					point: { x: e.clientX + 5, y: e.clientY },
					menuItems,
				})
			);
		}
	};
	return (
		<S.Base>
			{entry.selectedDomElements && entry.selectedDomElements.length > 0 && (
				<S.SelectedElementsContainer>
					{entry.selectedDomElements.map((element) => (
						<Pill key={element.id} label={getElementName(element)} />
					))}
				</S.SelectedElementsContainer>
			)}
			<S.Prompt onContextMenu={onContextMenuInPrompt}>{entry.prompt}</S.Prompt>
		</S.Base>
	);
};

export default EditEntry;
